import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { ManageTemplateComponent } from '../manage-template/manage-template.component';
import { PlanCardComponent } from '../plan-card/plan-card.component';
import { BehaviorSubject, Observable } from 'rxjs';
import { BENEFITS_KEY, PricePlanService } from 'src/app/components/Price-subscritions/priceplanService';
import { ApiService } from 'src/app/services/api.service';
import { AppSettings } from 'src/app/services/AppSettings';
import { FormValidation, SWAL_WITH_BUTTONS } from 'src/app/services/FormValidation';
import { UtilService } from 'src/app/services/util.service';
import Swal from 'sweetalert2';
import { CustomerService, TEXT_FIELDS } from '../customer-service.service';

@Component({
  selector: 'app-manage-networks',
  standalone: true,
  imports: [CommonModule, ManageTemplateComponent, PlanCardComponent],
  templateUrl: './manage-networks.component.html',
  styleUrls: ['./manage-networks.component.scss' ,  '../../../../../styles/admin/style.scss',
    "../../../../../styles/admin/app.scss"]
})
export class ManageNetworksComponent extends FormValidation{

  PLANMAX : number = 0;
  AVAILABLE : number = 0;
  ALLOCATED : number = 0;
  fields: Array<Partial<TEXT_FIELDS>>;
  columns: Array<Partial<TEXT_FIELDS>>;
  networkDetails !: any;
  networkData = new BehaviorSubject([]);
  teamId: any;
  focused : boolean = true;
  payload = {
    limit: 10,
    searchContent : null,
    status : null,
    searchAfterKey : null,
    type: "MANAGE"
  };
  prevSearchAfterKey : any;
  employeePrevSearchAfterKey : any;
  stopScroll : boolean = false;
  businessId: any;
  businessEmail: any;
  activeNetworks: number = 0;
  allocationCards = [
    {
      name : "Plan Max",
      value : null
    },
    {
      name : "Allocated",
      value : null
    },
    {
      name : "Active",
      value : null
    },
  ];

  constructor(private API: ApiService, private aRoute: ActivatedRoute,private util : UtilService,
    private customerService : CustomerService , private pricePlanService : PricePlanService
  ) {
    super();
    this.aRoute.queryParams.subscribe(res => {
      this.teamId = res.teamId;
      this.businessId = res.id;
      this.businessEmail = res.businessEmail;
    });

    this.fields = [
      { label: "Workspace Name", key: 'teamName' },
      { label: "Owner", key: 'owner' },
      { label: "Members", key: 'members' },
    ];

    this.columns = [
      { label: 'Network Name',
        key: 'businessNetworkName' ,
        route : true,
        path : "/user-management/network/details"
      },
      { label: 'Owner', key: 'fullName' },
      { label: 'Email', key: 'email' },
      { label: 'Role', key: 'role' },
      { label: 'Members', key: 'membersCount' },
    ];

  }

  ngOnDestroy(): void {
    this.networkData.unsubscribe();
  }


  ngOnInit(): void {
      this.getNetworks();
  }

  updateTeam(event) {
    let arr: any[] = [];
    arr.push(event);
    const updatedArray = arr.map(obj=>{
      const {members, ...rest} = obj;
      return rest;
    });
    this.API.create('business/managenetworkData', updatedArray).subscribe(res => {
      if (res && res.code === '00000') {
        this.networkDetails = event;
        Swal.fire({
          icon : "success",
          title : "Workspace Updated",
          text : "Updated Workspace Sucessfully!",
          showConfirmButton: false,
          allowOutsideClick : false,
          timer: 1000,
        })
      }
      this.util.stopLoader();
    });
  }

  async updateTeamMembers(members: any) {

    const userData = members.value;
    const  updatedData =  JSON.parse(JSON.stringify(this.networkData.getValue()));
    let data = {
      businessNetworkId: userData.businessNetworkId,
      status: userData.status
    };

    if(members.checked){
      this.util.startLoader();

      const plan = await this.customerService.getBusinessPLanBenefits(this.businessId , "PERSONAL_NETWORKS");

      if(plan.available > 0){
          this.updateMembersBulk(data);
      }
      else{
        updatedData.forEach(res=>{
          if(res.businessNetworkId === userData.businessNetworkId){
            res.status = "INACTIVE";
          }
        });
        this.networkData.next(updatedData);
        this.pricePlanService.expiredPopup(
          "PERSONAL_NETWORKS",
          "PAY",
          null,
          null,
          null,
          null,
          plan.available,
          plan.actual,
          plan.utilized,
          plan.promotional
        );
      }

      this.util.stopLoader();
    }
    else{
      SWAL_WITH_BUTTONS.fire({
        icon: "warning",
        showConfirmButton: true,
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        allowOutsideClick : false,
        title : "Inactive Network",
        text : `Are you sure you want to inactive ${userData.businessNetworkName}?`
      }).then(res=>{


        if(res.isConfirmed){
          this.updateMembersBulk(data);
        }
        else{
          updatedData.forEach(res=>{
            if(res.businessNetworkId === userData.businessNetworkId){
              res.status = "ACTIVE";
            }
          });
          this.networkData.next(updatedData);
        }

      });
      this.util.stopLoader();
    }





  }


  updateMembersBulk(data){
    this.API.create('business/manageNetworks', [data]).subscribe(res => {
      if (res && res.code === '00000') {
         Swal.fire({
          icon : "success",
          title : 'Network Updated!',
          text : "Network updated successfully",
          showConfirmButton: false,
          timer: 2000,
        });
        setTimeout(() => {
          this.payload.searchAfterKey = null;
          this.prevSearchAfterKey = null;
          this.stopScroll = false;
          this.networkData.next([]);
          this.getNetworks();
         }, 2000);
      this.util.stopLoader();

      }
    });
  }

  getNetworksList(payload: Object): Observable<any> {
    return this.API.create('business/getBusinessUsersNetworkList', payload);
  }

  getNetworks() {
    this.util.startLoader();
    this.getNetworksList({  businessId : this.businessId,  ...this.payload }).subscribe(response => {
      this.util.stopLoader();
      if (response.code === AppSettings.SUCESS_CODE) {
        const networkData = response.data.businessNetworkList;
        const searchKey = response.data.searchAfterKey;
        if(response?.data?.activeCount && this.payload.searchAfterKey==null || response?.data?.activeCount==0 && this.payload.searchAfterKey==null){
          this.activeNetworks= response?.data?.activeCount;
        }


        if (networkData) {
          const current = networkData;
          const exist = this.networkData.getValue();
          const mapped = [...exist , ...current];

          mapped.forEach(element => {
                element.fullName =  element.userData.firstName + " " + element.userData.lastName,
                element.email =  element.userData.email,
                element.role =  'Super Admin';
          });

          this.networkData.next(mapped);
        }

        if(networkData != null && (networkData.length === 0 ||
          JSON.stringify(this.prevSearchAfterKey) === JSON.stringify(searchKey))){
          this.stopScroll = true;
        }
        this.prevSearchAfterKey =  searchKey;

        let plan = response.data.businessPlanUsage;
        let found =  (plan.benefitsUsages && plan.benefitsUsages.
          find(x => (x.benefitKey as BENEFITS_KEY) === 'PERSONAL_NETWORKS'));
        if(found){
          this.PLANMAX = found.actual == 99999999 ? 'Unlimited' : found.actual;
          this.AVAILABLE = found.actual == 99999999 ? 'Unlimited' : found.available;
          this.ALLOCATED = found.utilized;
          this.allocationCards[0].value = this.PLANMAX;
          this.allocationCards[1].value = this.ALLOCATED;
          this.allocationCards[2].value = this.activeNetworks;
        }

        // const { adminUserData, ...rest } = response.data.networkData;
        // let data = {
        //   ...rest,
        //   owner: adminUserData.firstName + " " + adminUserData.lastName,
        //   members: rest.memberCnt,
        //   userId : adminUserData.userId,
        //   adminUserData : adminUserData
        // }
        this.networkDetails = {};

      }

    });

  }


  onSearch(value , obj : ManageNetworksComponent){
    obj.payload = {
      ...obj.payload,
      searchContent : value,
      searchAfterKey : null
    };
    obj.stopScroll = false;
    obj.prevSearchAfterKey = null;
    obj.networkData.next([]);
    obj.getNetworks();
  }

  onFilter(data , obj : ManageNetworksComponent){
    console.log("FILTERED DATA" , data);
    obj.payload = {
      ...obj.payload,
      status : data.status,
      searchAfterKey : null
    }
    obj.stopScroll = false;
    obj.prevSearchAfterKey = null;
    obj.networkData.next([]);
    obj.getNetworks();
  }

  onScroll(obj : ManageNetworksComponent){
    if(!this.stopScroll){
      obj.payload = {
        ...obj.payload,
        searchAfterKey : obj.prevSearchAfterKey
      };
      obj.getNetworks();
    }
  }

}
